import React from "react";
import "./TeamHero.css";

const TeamHero = () => {
  return (
    <section className="team-hero-section">
      <div className="container">
        <div className="team-hero-content">
          <h1 className="hero-title team-hero-title">
            <span className="darkO-txt">Operators First.</span> Infrastructure
            <br />
            Builders Always.
          </h1>

          <p className="hero-para team-hero-copy">
            EdTech Ventures was built by founders who&apos;ve taken companies
            from zero to exit — and who understand that the future of workforce
            development is skills-based and AI-driven.
          </p>

          <div className="team-hero-notes">
            <p>We are not passive investors.</p>
            <p>We embed inside companies to build defensible infrastructure.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamHero;